<template>
  <div class="swiper-conter">
    <swiper ref="mySwiper" :options="swiperOptions">
      <!-- <swiper-slide v-for="(item,index) in hotelList " :key="index">
        <img v-for="(hotel,hotelindex) in item " :key="hotelindex" :class="`sw-hotel${hotel}`" />
      </swiper-slide>-->
      <swiper-slide>
        <img src="../assets/img/hotel/01.png" />
        <img src="../assets/img/hotel/02.png" />
        <img src="../assets/img/hotel/03.png" />
        <img src="../assets/img/hotel/04.png" />
        <img src="../assets/img/hotel/05.png" />
        <img src="../assets/img/hotel/06.png" />
        <img src="../assets/img/hotel/07.png" />
        <img src="../assets/img/hotel/08.png" />
      </swiper-slide>
      <swiper-slide>
        <img src="../assets/img/hotel/11.png" />
        <img src="../assets/img/hotel/12.png" />
        <img src="../assets/img/hotel/13.png" />
        <img src="../assets/img/hotel/14.png" />
        <img src="../assets/img/hotel/15.png" />
        <img src="../assets/img/hotel/16.png" />
        <img src="../assets/img/hotel/17.png" />
        <img src="../assets/img/hotel/18.png" />
      </swiper-slide>
      <swiper-slide>
        <img src="../assets/img/hotel/21.png" />
        <img src="../assets/img/hotel/22.png" />
        <img src="../assets/img/hotel/23.png" />
        <img src="../assets/img/hotel/24.png" />
      </swiper-slide>
    </swiper>
    <div class="swiper-button-next"></div>
    <div class="swiper-button-prev"></div>
  </div>
</template>
<script>
export default {
  name: "carrousel",
  data() {
    return {
      swiperOptions: {
         loop: true,
        speed: 2000,
        mousewheelControl: true,
        autoplay: {
          disableOnInteraction: false,
          delay: 2000,
        },
        // pagination: {
        //   el: ".swiper-pagination",
        //   clickable: true
        // },
        nextButton: ".swiper-button-next", // 前进按钮的css选择器或HTML元素。
        prevButton: ".swiper-button-prev", // 后退按钮的css选择器或HTML元素。
        observeParents: true,
        observer: true,
      },
      hotelList: [
        ["01", "02", "03", "04", "05", "06", "07", "08"],
        ["11", "12", "13", "14", "15", "16", "17", "18"],
        ["21", "22", "23", "24"]
      ]
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.swiper.slideTo(0, 1000, true);
    });
  }
};
</script>

<style lang="scss" scoped>
@import "@css/style.scss";
.swiper-button-prev,.swiper-button-next{
  display: none !important;
}
.swiper-conter {
  height: 3.65rem;
  width: 100%;
  position: relative;
  .swiper-slide {
    width: 100%;
    box-sizing: border-box;
    padding-right: px2rem(20);
    padding-left: px2rem(20);
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    img {
      width: px2rem(96);
      height: px2rem(96);
      margin: px2rem(20);
      //   background: rgba(170, 170, 170, 0) url("../assets/img/hotel/01.png")
      //     no-repeat top right;
      background-size: 100%;
    }
    // .sw-hotel01 {
    //   background-image: url("../assets/img/hotel/01.png");
    // }
    // .sw-hotel02 {
    //   background-image: url("../assets/img/hotel/02.png");
    // }
    // .sw-hotel03 {
    //   background-image: url("../assets/img/hotel/03.png");
    // }
    // .sw-hotel04 {
    //   background-image: url("../assets/img/hotel/04.png");
    // }
    // .sw-hotel05 {
    //   background-image: url("../assets/img/hotel/05.png");
    // }
    // .sw-hotel06 {
    //   background-image: url("../assets/img/hotel/06.png");
    // }
    // .sw-hotel01 {
    //   background-image: url("../assets/img/hotel/01.png");
    // }
    // .sw-hotel07 {
    //   background-image: url("../assets/img/hotel/07.png");
    // }
    // .sw-hotel08 {
    //   background-image: url("../assets/img/hotel/08.png");
    // }

    // .sw-hotel11 {
    //   background-image: url("../assets/img/hotel/11.png");
    // }
    // .sw-hotel12 {
    //   background-image: url("../assets/img/hotel/12.png");
    // }
    // .sw-hotel13 {
    //   background-image: url("../assets/img/hotel/13.png");
    // }
    // .sw-hotel14 {
    //   background-image: url("../assets/img/hotel/14.png");
    // }
    // .sw-hotel15 {
    //   background-image: url("../assets/img/hotel/15.png");
    // }
    // .sw-hotel16 {
    //   background-image: url("../assets/img/hotel/16.png");
    // }
    // .sw-hotel17 {
    //   background-image: url("../assets/img/hotel/17.png");
    // }
    // .sw-hotel18 {
    //   background-image: url("../assets/img/hotel/18.png");
    // }
    // .sw-hotel21 {
    //   background-image: url("../assets/img/hotel/21.png");
    // }
    // .sw-hotel22 {
    //   background-image: url("../assets/img/hotel/22.png");
    // }
    // .sw-hotel23 {
    //   background-image: url("../assets/img/hotel/23.png");
    // }
    // .sw-hotel24 {
    //   background-image: url("../assets/img/hotel/24.png");
    // }
  }
}
.swiper-button-next:after,
.swiper-button-prev:after {
  color: rgba(183, 183, 183, 1);
  font-size: px2rem(32);
}
.swiper-button-prev {
  left: px2rem(-30);
  top: 37%;
}
.swiper-button-next {
  right: px2rem(-30);
  top: 37%;
}
</style>
